
import React from 'react'

export default function LoginBackground() {
    return (
        <div className="s">
            <div className="a"></div>
            <div className="b"></div>
            <div className="c"></div>
            <div className="d"></div>
        </div>
    )
}
